<div id="home">
  <app-home-header
    [userEnterprises]="userEnterprises"
    [selectedEnterprise]="selectedEnterprise"
    [loadingEnterprises]="loadingEnterprises"
    (selectEnterpriseEvent)="onSelectEnterprise($event)" />

  <div class="home-gradient-shadow">
    <div class="home-container">
      @if (!loadingEnterprises && (plantationService.loading$ | async) === false) {
        @if (userEnterprises?.length > 0) {
          <div class="row home-content-row">
            <div class="col-12 col-lg-8 home-main-column">
              <div class="home-map" [class.fullscreen]="isMapFullScreen">
                <dk-map-widget
                  #mapWidget
                  [selectedEnterprise]="selectedEnterprise"
                  [isFullScreen]="isMapFullScreen"
                  (fullScreen)="fullScreenToggle()"></dk-map-widget>
              </div>
              <div class="row home-bottom-row">
                <div class="col-12 col-lg-6">
                  <div class="problematic-spots">
                    <app-home-problematic-spots
                      [selectedEnterprise]="selectedEnterprise"
                      [hasAnyPremiumForSpotDetection]="hasAnyPremiumForSpotDetection"
                      (analyticsProblematicSpotsLoaded)="onHomeProblematicSpotsAnalyticsLoaded($event)"
                      (getPremiumEvent)="getPremium('spot-detection')" />
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="upcoming-irrigation">
                    <app-home-upcoming-irrigations
                      [selectedEnterprise]="selectedEnterprise"
                      [hasIrrigationProgramAccess]="hasIrrigationProgramAccess"
                      (getPremiumEvent)="getPremium('irrigation-program')" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 home-alerts-column">
              <div class="warnings-and-alerts">
                <app-home-warnings-and-alerts
                  [selectedEnterprise]="selectedEnterprise"
                  (analyticsWarningsLoaded)="onHomeWarningsAnalyticsLoaded($event)"
                  (requestCallbackEvent)="openRequestCallback()" />
              </div>
            </div>
          </div>
        } @else {
          <div class="row enterprise-error">
            <div class="col-12 col-md-6 col-lg-4">
              <widget-info-box
                [isErrorState]="true"
                [title]="'doktar_app.home.warnings.not_load_homepage_title' | translate"
                [description]="
                  'doktar_app.home.warnings.not_load_homepage_description' | translate
                "
                (primaryButtonClick)="getUserEnterprises()" />
            </div>
          </div>
        }
      } @else {
        <div class="row home-content-row">
          <div class="col-12 col-lg-8 home-main-column">
            <div class="home-map">
              <div class="skeleton">
                <p-skeleton width="100%" height="100%" />
              </div>
            </div>

            <div class="row home-bottom-row">
              <div class="col-12 col-lg-6">
                <div class="problematic-spots">
                  <div class="skeleton">
                    <p-skeleton width="100%" height="100%" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="upcoming-irrigation">
                  <div class="skeleton">
                    <p-skeleton width="100%" height="100%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 home-alerts-column">
            <div class="warnings-and-alerts">
              <div class="skeleton">
                <p-skeleton width="100%" height="100%" />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="tutorialDialogVisible"
  [modal]="true"
  [dismissableMask]="false"
  appendTo="body"
  [closeOnEscape]="false"
  [draggable]="false"
  [closable]="false"
  styleClass="tutorial-modal"
  [style]="{ width: '344px', height: 'auto', borderRadius: '12px' }">
  <ng-template #content>
    <div class="modal-header-background">
      <dk-seed-icon-white />
      <span class="company-name">{{ 'company.name' | translate }}</span>
    </div>
    <div class="content-container">
      <span class="tutorial-title">
        {{ 'doktar_app.auth.welcome.title' | translate }}
      </span>
      <span class="tutorial-description">
        {{ 'doktar_app.home.welcome.desc' | translate }}
      </span>
    </div>
    <div class="modal-buttons">
      <dk-button
        [label]="'doktar_app.land_plantations.land_adding.continue_button' | translate"
        severity="primary"
        size="xlarge"
        (click)="openLandsPopover()" />
    </div>
  </ng-template>
</p-dialog>
<dk-account-request-callback #requestCallback></dk-account-request-callback>

<dk-support-chat-bubble></dk-support-chat-bubble>
